import React from 'react';

import { css, cx } from '@emotion/css';
import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { UseFormReturn, useForm } from 'react-hook-form';

import { useStyles } from '@/hooks/useStyles.ts';
import { Form } from '@/uiKit/atoms/Form.tsx';
import {
  CarePlanRenewalInfo,
  SimpleCarePlanRenewalInfo,
  carePlanRenewalSchema,
} from '@/uiKit/organisms/PatientCreationAndRenewal/CarePlan/CarePlanRenewal.ts';

export const CARE_PLAN_RENEWAL_FORM_ID = 'care-plan-renewal-info-form';

export type CarePlanRenewalFormProps = {
  carePlanInfo?: Partial<SimpleCarePlanRenewalInfo>;
  onSubmit: (data: CarePlanRenewalInfo) => void;
  className?: string;
  children?:
    | React.ReactNode
    | ((
        formContext: UseFormReturn<SimpleCarePlanRenewalInfo>,
      ) => React.ReactNode);
};

export const CarePlanRenewalForm: React.FC<CarePlanRenewalFormProps> = ({
  carePlanInfo,
  onSubmit,
  children,
  className,
}) => {
  const styles = useStyles(makeStyles);

  const form = useForm<SimpleCarePlanRenewalInfo>({
    resolver: standardSchemaResolver(carePlanRenewalSchema),
    defaultValues: {
      duration: '3',
      ...carePlanInfo,
    },
  });

  return (
    <Form
      id={CARE_PLAN_RENEWAL_FORM_ID}
      formContext={form}
      onSubmit={data => onSubmit(data as CarePlanRenewalInfo)}
      className={cx(styles.container, className)}
    >
      {typeof children === 'function' ? children(form) : children}
    </Form>
  );
};

const makeStyles = () => ({
  container: css({}),
});
